import React from "react";
import { useTranslation } from "react-i18next";
import { useTaxonomy } from "library/utils/useTaxonomy";
import { CenteredCell } from "../../../components/styled";

interface PowerTypeCellProps {
  powerType?: string | null;
}

export const PowerTypeCell: React.FC<PowerTypeCellProps> = ({ powerType }) => {
  const { t } = useTranslation();
  const taxonomy = useTaxonomy();

  if (!powerType) {
    return <CenteredCell>-</CenteredCell>;
  }

  // Look up the taxonomy item by code
  const powerTypeTaxonomy = taxonomy?.VehiclePowerType?.byId?.[powerType];

  if (!powerTypeTaxonomy) {
    return <CenteredCell>{powerType}</CenteredCell>;
  }

  // Translate the code for power types (these DO have translations)
  return (
    <CenteredCell>
      {t(powerTypeTaxonomy.code, powerTypeTaxonomy.code)}
    </CenteredCell>
  );
};
